import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getConfig, revealConfig, saveConfig } from '../services/bankTransferConfigService';
import type { SaveBankTransferConfigRequest } from '../types/bankTransferConfig';

export const BANK_TRANSFER_CONFIG_KEYS = {
  summary: (apartmentId: string) =>
    ['bank-transfer-config', apartmentId] as const,
  reveal: (apartmentId: string) =>
    ['bank-transfer-config', apartmentId, 'reveal'] as const,
};

export const useBankTransferConfigSummary = (apartmentId: string) => {
  void apartmentId;
  return useQuery({ queryKey: BANK_TRANSFER_CONFIG_KEYS.summary(apartmentId), queryFn: () => getConfig(apartmentId) });
};

export const useRevealBankTransferConfig = (apartmentId: string) => {
  void apartmentId;
  return useQuery({
    queryKey: BANK_TRANSFER_CONFIG_KEYS.reveal(apartmentId),
    queryFn: () => revealConfig(apartmentId),
    staleTime: 0,
    gcTime: 0,
    enabled: false,
  });
};

export const useSaveBankTransferConfig = (apartmentId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      request,
      idempotencyKey,
      version,
    }: {
      request: SaveBankTransferConfigRequest;
      idempotencyKey: string;
      version: number | null;
    }) => saveConfig(apartmentId, request, idempotencyKey, version),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BANK_TRANSFER_CONFIG_KEYS.summary(apartmentId) });
    },
  });
};
